// basic vue usage
import App from "./App.vue";
import Vue from "vue";
import router from "./router";
import store from "./store";
// json schema, form packages
import VueFormulate from "@braid/vue-formulate";
// styling, themes
import "material-design-icons-iconfont/dist/material-design-icons.css";
import vuetify from "./plugins/vuetify";
import Element from "element-ui";
import "../node_modules/element-theme-chalk/lib/index.css";
import "./styles/style.css";
import VueSimpleAlert from "vue-simple-alert";

Vue.config.productionTip = false;

Vue.use(VueFormulate); // for form construction
Vue.use(Element); // for form design
Vue.use(VueSimpleAlert); // pre designed alerts

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
